<template>
	<div class="vstack">
		<div class="hstack gap-3 justify-content-between align-items-center">
			<div class="vstack lh-sm">
				<h5>{{ title }}</h5>
				<div class="text-xs text-muted">{{ dateTitle }}</div>
			</div>
		</div>
		<div class="hstack gap-2 mt-2">
			<LayoutBlockStat title="Reconquistas totales">
				{{ total }}
			</LayoutBlockStat>
		</div>
		<div class="mx-n1">
			<Responsive class="w-full">
				<template #main="{ width }">
					<Chart :size="{ width, height: 300 }" :margin="{ left: 5, top: 15, right: 5, bottom: 5 }" :data="data" :axis="axis">
						<template #layers>
							<Grid strokeDasharray="1,0" :hideX="true" :hideY="true" />
							<Line :dataKeys="['name', 'all' ]" :lineStyle="{ stroke: '#1b73e8', strokeWidth: 3 }" :dotStyle="{ fill: '#1b73e8', strokeWidth: 2 }" type="monotone" />
						</template>
						<template #widgets>
							<Tooltip color="#0f172a" :config="tooltipConfig" />
						</template>
					</Chart>
				</template>
			</Responsive>
		</div>
	</div>
</template>

<script>
	import { ref, computed } from 'vue';
	import _ from 'lodash';
	import moment from 'moment';
	import { Responsive, Chart, Grid, Line, Tooltip } from 'vue3-charts';
	import { formatBetween, getDateRange } from '@/composables/date';

	export default {
		components: { Responsive, Chart, Grid, Line, Tooltip },
		props: {
			title: String,
			filters: Object,
			totals: Object
		},
		setup(props) {
			const dateTitle = formatBetween(props.filters.start_date, props.filters.end_date);
			const dateArray = getDateRange(props.filters.start_date, props.filters.end_date);
			const data = computed(() => {
				let detail = [];

				_.forEach(dateArray, (index) => {
					let info = {
						name: index
					};

					if(index in props.totals) {
						info.all = props.totals[index]?.all;
					}

					detail.push(info);
				});

				return detail;
			});

			const tooltipConfig = computed(() => {
				let detail = [];

				detail['name'] = { label: 'Fecha' };
				detail['all'] = { label: 'Cantidad', format: ',.0f' };

				return detail;
			});

			const total = computed(() => {
				let data = 0;

				_.forEach(props.totals, (item) => {
					data+= item.all;
				});

				return data.toLocaleString(undefined);
			});

			const xAxisDivisor = computed(() => {
				let max = 8,
					length = dateArray.length;

				if(length <= max) return 1;
				else return Math.ceil(length / max);
			});

			const axis = ref({
				primary: {
					type: 'band',
					format: (val, index) => {
						return (index % xAxisDivisor.value === 0) ? moment(val).format('DD/MM') : null;
					}
				},
				secondary: {
					type: 'linear',
					ticks: 3,
					format: (val, index) => {
						return (index % 2 === 0) ? val.toLocaleString() : null;
					}
				}
			});

			return { dateTitle, dateArray, data, tooltipConfig, total, axis }
		}
	}
</script>